// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Autocomplete__container-dda600 {
  display: flex;
  gap: 8px;
}

.Autocomplete__container-list-d769f4 {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 252px;
  overflow-y: auto;
}

.Autocomplete__text-field-a665cc {
  flex-grow: 1;
}

.Autocomplete__popover-bca983 {
  padding: 4px 0;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/Autocomplete/Autocomplete.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  gap: 8px;\n}\n\n.container-list {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  max-height: 252px;\n  overflow-y: auto;\n}\n\n.text-field {\n  flex-grow: 1;\n}\n\n.popover {\n  padding: 4px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Autocomplete__container-dda600`,
	"container-list": `Autocomplete__container-list-d769f4`,
	"containerList": `Autocomplete__container-list-d769f4`,
	"text-field": `Autocomplete__text-field-a665cc`,
	"textField": `Autocomplete__text-field-a665cc`,
	"popover": `Autocomplete__popover-bca983`
};
module.exports = ___CSS_LOADER_EXPORT___;
